import { StatusBadge } from '@src/common/components/StatusBadge';
import { permitStatusColors } from '@src/orders/components/OrderStatusColors';
import type { PermitStatus } from '@src/orders/domain/PermitApplication';
import { useTranslation } from 'react-i18next';

interface Props {
  status: PermitStatus;
}

export const PermitStatusBadge = ({ status }: Props) => {
  const { t } = useTranslation();

  return (
    <StatusBadge
      size="small"
      text={t(status.toLowerCase())}
      color={permitStatusColors[status].color}
      borderColor={permitStatusColors[status].border}
      backgroundColor={permitStatusColors[status].background}
    />
  );
};

interface Props {
  status: PermitStatus;
}
